/**
 * The tent, drawn — the one brand mark, red square behind a white A-frame.
 * Size via a Tailwind class (`size-…`); the svg scales with its box.
 */
export function TentMark({ className = "size-[30px]" }: { className?: string }) {
  return (
    <span
      className={`grid place-items-center rounded-lg bg-rood text-kaart ${className}`}
      aria-hidden="true"
    >
      {/* Decorative only; the wrapping span is aria-hidden. */}
      <svg viewBox="0 0 24 22" role="presentation" className="h-1/2 w-[53%]">
        <path d="M12 2 22.5 20H14.6L12 15.4 9.4 20H1.5Z" fill="currentColor" />
      </svg>
    </span>
  );
}
